class Cache {
  EXPIRE = 24 * 60 * 60 * 1000

  set(key, data, expire = this.EXPIRE) {
    window.localStorage.setItem(
      key,
      typeof data === 'object' ? JSON.stringify(data) : data,
      expire
    )
  }

  get(key) {
    const result = window.localStorage.getItem(key)
    if (result) return JSON.parse(result)
    return null
  }

  remove(key) {
    window.localStorage.removeItem(key)
  }

  clearAll() {
    window.localStorage.clear()
  }
}

export default new Cache()
